import React, { useContext, createContext, useState, useEffect } from "react";
import useSWR, { mutate } from "swr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faUsers } from "@fortawesome/free-solid-svg-icons";
import TableTotalNCost from "./TableTotalNCost";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SearchFilter from "./SearchFilter";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimation";
import { RoleContext } from "./App";
import SecureLS from "secure-ls";

// Secure Local Storage setup
const ls = new SecureLS({ encodingType: "aes" });
const username = ls.get("username");
const userpw = ls.get("userpw");
const usercsrf_token = ls.get("usercsrf_token");

// Base URL from environment or fallback
const BASE_URL =
  process.env.REACT_APP_DRUPAL_BASE_URL || "https://svms.salcommsystems.click";

// Context
export const ReportDetailsCont = createContext(null);
export const useReportDetails = () => useContext(ReportDetailsCont);

// Fetcher with auth headers and CSRF
const fetcher = async (url) => {
  const res = await fetch(url, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
      "X-CSRF-Token": usercsrf_token,
    },
  });
  if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
  return res.json();
};

// Date Parser
function parseDate(dateStr) {
  if (!dateStr) return null;
  const isoDate = new Date(dateStr);
  return isNaN(isoDate.getTime()) ? null : isoDate;
}

const DeliveriesRegister = () => {
  // ✅ Use roles from context and destructure
  const { roles } = useContext(RoleContext);
  console.log("roles:", roles);
  const { stateNavigator } = useContext(NavigationContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");

  // Auto-refresh every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      mutate(`${BASE_URL}/delivery-api?_format=json`);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Fetch deliveries data
  const { data, error, isLoading } = useSWR(
    `${BASE_URL}/delivery-api?_format=json`,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
    }
  );

  if (error)
    return (
      <LoaderAnimation loadingTxt="Failed to load deliveries. Please try again." />
    );
  if (isLoading) return <LoaderAnimation loadingTxt="Loading..." />;

  // ✅ Ensure data is an array
  const deliveries = Array.isArray(data) ? data : [];

  const filteredData = deliveries.filter((delivery) => {
    // If no filters applied, show all
    const isFilterEmpty =
      !searchTerm.trim() && !requestStartDate && !requestEndDate;
    if (isFilterEmpty) return true;

    const search = searchTerm.trim().toLowerCase();

    // Exact match for searchable fields
    const matchesStaffID =
      (delivery.field_staff_id || "").toLowerCase() === search;
    const matchesDeliveryCompany =
      (delivery.field_delivery_company || "").toLowerCase() === search;
    const matchesDeliveredBy =
      (delivery.field_delivered_by || "").toLowerCase() === search;
    const matchesNotes =
      (delivery.field_delivery_notes_comments || "").toLowerCase() === search;
    const matchesContact =
      (delivery.field_delivery_contact_number || "").toLowerCase() === search;

    const matchesSearchTerm =
      matchesStaffID ||
      matchesDeliveryCompany ||
      matchesDeliveredBy ||
      matchesNotes ||
      matchesContact;

    // Date filtering
    let matchesDate = true;
    if (requestStartDate || requestEndDate) {
      const deliveryDate = parseDate(delivery.field_delivery_date_time);
      if (!deliveryDate) return false;

      const startDate = requestStartDate ? new Date(requestStartDate) : null;
      const endDate = requestEndDate ? new Date(requestEndDate) : null;

      if (startDate) startDate.setHours(0, 0, 0, 0);
      if (endDate) endDate.setHours(23, 59, 59, 999);

      matchesDate =
        (!startDate || deliveryDate >= startDate) &&
        (!endDate || deliveryDate <= endDate);
    }

    return matchesSearchTerm && matchesDate;
  });

  // Stats
  const totalDeliveries = filteredData.length;
  // const deliveredToday = filteredData.filter((d) => {
  //   const dDate = parseDate(d.field_delivery_date_time);
  //   if (!dDate) return false;
  //   const today = new Date();
  //   return (
  //     dDate.getDate() === today.getDate() &&
  //     dDate.getMonth() === today.getMonth() &&
  //     dDate.getFullYear() === today.getFullYear()
  //   );
  // }).length;

  // const pendingDeliveries = filteredData.filter(
  //   (d) => !d.field_delivery_date_time
  // ).length;

  const iconStyle = (color) => ({
    backgroundColor: color,
    borderRadius: "50%",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  });

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus AddTitle="Deliveries Register" />

          {/* Stats Boxes */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "20px 0",
              gap: "20px",
            }}
          >
            {/* <div
              style={{
                flex: 1,
                padding: "34px",
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <div style={iconStyle("#05A550")}>
                <FontAwesomeIcon icon={faDollyBox} size="lg" color="#fff" />
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: "16px", color: "#333" }}>
                  Delivered Today
                </h3>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#05A550",
                  }}
                >
                  {deliveredToday}
                </p>
              </div>
            </div> */}

            <div
              style={{
                flex: 1,
                padding: "34px",
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <div style={iconStyle("#007bff")}>
                <FontAwesomeIcon icon={faUsers} size="lg" color="#fff" />
              </div>
              <div>
                <h3 style={{ margin: 0, fontSize: "16px", color: "#333" }}>
                  Total Deliveries
                </h3>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#007bff",
                  }}
                >
                  {totalDeliveries}
                </p>
              </div>
            </div>
          </div>

          {/* Search */}
          <SearchFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            requestStartDate={requestStartDate}
            setRequestStartDate={setRequestStartDate}
            requestEndDate={requestEndDate}
            setRequestEndDate={setRequestEndDate}
          />

          {/* Table */}
          {filteredData.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Staff ID</th>
                  <th>Received By</th>
                  <th>Delivered By</th>
                  <th>Delivery Company</th>
                  <th>Delivery Contact</th>
                  <th>Delivery Date & Time</th>
                  <th>Notes / Comments</th>
                  {(roles.includes("administrator") ||
                    roles.includes("consularadmin")) && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {filteredData.map((delivery) => (
                  <tr key={delivery?.nid}>
                    <td>{delivery?.field_staff_id}</td>
                    <td>{`${delivery?.field_firist_name || ""} ${
                      delivery?.field_last_name || ""
                    }`}</td>
                    <td>{delivery?.field_delivered_by}</td>
                    <td>{delivery?.field_delivery_company || ""}</td>
                    <td>{delivery?.field_delivery_contact_number || ""}</td>
                    <td>{delivery?.field_delivery_date_time || ""}</td>
                    <td>{delivery?.field_delivery_notes_comments || ""}</td>
                    {(roles.includes("administrator") ||
                      roles.includes("consularadmin")) && (
                      <td className="formActionBtn">
                        <button
                          className="actionBTN"
                          onClick={() =>
                            stateNavigator.navigate("deliverieseditregister", {
                              deliveryNID: delivery?.nid,
                              deliveryUUID: delivery?.uuid,
                              deliveryCompany: delivery?.field_delivery_company,
                              deliveredBy: delivery?.field_delivered_by,
                              deliveryNotesComment:
                                delivery?.field_delivery_notes_comments,
                              deliveryContact:
                                delivery?.field_delivery_contact_number,
                            })
                          }
                        >
                          <FontAwesomeIcon
                            icon={faEdit}
                            size={16}
                            color="gray"
                          />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoaderAnimation loadingTxt="No matching deliveries found" />
          )}

          {filteredData.length > 0 && (
            <TableTotalNCost
              noOfReportLable="Number of Deliveries :"
              noOfReportLength={filteredData?.length}
              totalReportFeeCostLable=""
              totalReportFeeCostValue={null}
            />
          )}
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default DeliveriesRegister;
